module.exports = __webpack_public_path__ + "static/media/rayadoElegante.7d67173c.jpg";